import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';

/**
 * This hook is a wrapper around useExperimentFlag
 * @param {string} flagName The name of the feature flag
 * @param {any} defaultValue The default value of the feature flag
 * @param {boolean} skipEvaluation If true, the flag will not be evaluated
 * @returns {[any,boolean]}
 */
export default function useFeatureFlag(flagName, defaultValue = false, skipEvaluation = false) {
  // if skipEvaluation is true, don't evaluate the flag
  const experimentFlag = useExperimentFlag(flagName, defaultValue, true, skipEvaluation);

  return [experimentFlag.value, experimentFlag.loading];
}
